import { OnInit, Component, Inject } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DOCUMENT, Location } from '@angular/common';
import { AuthService, WindowService } from 'src/app/service/api';
import { environment } from 'src/environments/environment';
import { UserInfo } from 'src/app/common/interfaces/user.interface';
@Component({
  templateUrl: 'error.component.html',
  styleUrls: ['error.component.scss'],
})
export class ErrorComponent implements OnInit {
  title: string = '';
  description: string = '';
  secondaryDescription: string = '';
  notFoundPage = false;
  phoneIdRedirect = false;
  unregisteredIp = false;
  loginLink = `${environment.api}/oauth2/authorization/samsung?redirect_uri=${window.location.protocol}//${window.location.host}`;
  userInfo: UserInfo;
  gnbElement: HTMLElement;
  private _window: WindowService;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthService,
    private location: Location,
    private windowService: WindowService,
    @Inject(DOCUMENT) private document: Document
  ) {
    this._window = this.windowService;
  }

  ngOnInit() {
    this.gnbElement = this.document.getElementById('gnb');
    this.route.params.subscribe(({ path }) => this.initializeInfo(path));
    this.gnbElement.style.display = 'none';
    this.getUserInfo();
  }

  getUserInfo() {
    this.authService.userInfo$.subscribe((userInfo) => (this.userInfo = userInfo));
  }

  goBack() {
    this.location.back();
  }

  redirectSamsungAccount() {
    this._window.open('https://account.samsung.com/membership/contents/profile/profile-gate', '_blank');
  }

  initializeInfo(path: string) {
    switch (path) {
      case 'invite-expire':
        this.title = 'This invitation expired.';
        this.description = 'Please contact the owner of the project to re-send the invitation.';
        break;
      case 'invite-invalid':
        this.title = 'This invitation is invalid.';
        this.description = 'Please contact the owner of the project to re-send the invitation.';
        break;
      case 'service-unavailable':
        this.title = 'Service Temporarily Unavailable';
        this.description = 'Please contact the administrator for more information.';
        break;
      case 'maximum-members-exceeded':
        this.title = 'The maximum number of members exceeded.';
        this.description = 'Please contact the owner of the project to re-send the invitation.';
        break;
      case 'maximum-project-limit-exceeded':
        this.title = 'The maximum number of project exceeded.';
        this.description = 'Please make sure you have less than 10 projects to accept this invitation.';
        break;
      case 'account-deleted':
        this.title = 'Account deleted';
        this.description = 'Your Samsung Account Developer Console account was deleted.';
        break;
      case 'not-member':
        this.title = 'You are not a member of the project.';
        this.description = 'Please request an invitation from a member of the project.';
        break;
      case 'phone-id-not-supported':
        this.title = 'Phone ID not supported';
        this.description =
          'Samsung Account Developer Console does not support mobile phone number ID sign-in. Please sign with your email ID';
        this.phoneIdRedirect = true;
        break;
      case 'unregistered-ip':
        this.title = 'Unregistered IP [403]';
        this.description =
          '보안팀 권고 사항으로 접근이 차단되어 있습니다. 접근이 가능한 본사 담당자를 통해 APP ID를 생성하여주시기 바랍니다.';
        this.secondaryDescription =
          'Access is blocked due to security team recommendations. Please create an APP ID through an accessible head office representative.';
        this.unregisteredIp = true;
        break;
      case 'error':
        const error_code = this.route.snapshot.queryParams.error_code;
        if (error_code === 'AUT004') {
          this.router.navigateByUrl('/phone-id-not-supported');
        }
        break;
      default:
        this.title = 'Page not found [404]';
        this.description =
          'Sorry, we couldn’t find the page you requested. This page may have moved, or the address may not be correct.';
        this.notFoundPage = true;
    }
  }
}
